import dictionary from "../translations/dictionary.json";
import countryCodes from "../constants/countryCodes.json";

// Translations are bundled with the app (src/translations/dictionary.json) so pages
// never wait for the app manager. Keys are "rc-" + the English text, lowercased and trimmed.
export const DEFAULT_LANG = "fr";

export const getLang = () => {
  try {
    return localStorage.getItem("lang") || DEFAULT_LANG;
  } catch (e) {
    return DEFAULT_LANG;
  }
};

export const getTranslation = (text, defaultFrench, defaultGerman) => {
  if (text === null || text === undefined || text === "") return text ?? "";
  const lang = getLang();
  const entry = dictionary[`rc-${String(text).toLowerCase()}`.trim()];

  if (entry?.[lang]) return entry[lang];
  if (lang === "fr" && defaultFrench) return defaultFrench;
  if (lang === "gr" && defaultGerman) return defaultGerman;
  return entry?.en || String(text).trim();
};

// app language -> BCP 47 locale (dates, numbers, country names)
const LOCALES = { en: "en", fr: "fr", gr: "de", dt: "nl" };
export const getLocale = () => LOCALES[getLang()] || "fr";

let regionNames = null;
// countries are stored with their English name; show them in the current language
export const getCountryName = (name) => {
  const code = countryCodes[name];
  if (!code) return name ?? "";
  try {
    regionNames = regionNames || new Intl.DisplayNames([getLocale()], { type: "region" });
    return regionNames.of(code) || name;
  } catch (e) {
    return name;
  }
};
